<div class="panel panel--{{ panelSpacing() }}">
  <ng-content />
</div>
